import { Col } from "react-bootstrap";

import { decodeHTML } from "helpers/commonHelpers";

type QuotationDetailServiceConfirmationItemProps = {
  label: string;
  value: React.ReactNode;
  additionalValue?: string;
};

function QuotationDetailServiceConfirmationItem(props: QuotationDetailServiceConfirmationItemProps) {
  const { label, value, additionalValue } = props;

  return (
    <Col md={6} className="mb-3xl">
      <div className="text-xs text-secondary-v2 font-medium">{label}</div>
      <div
        className="text-sm text-primary"
        style={{
          maxWidth: "500px",
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "break-word",
        }}
      >
        {typeof value === "string" ? decodeHTML(value) : value} {additionalValue && `- ${additionalValue}`}
      </div>
    </Col>
  );
}

export default QuotationDetailServiceConfirmationItem;

QuotationDetailServiceConfirmationItem.defaultProps = {
  additionalValue: undefined,
};
